import {Controller} from '@stimulus/core'
import HSFileAttach from '../../../../../vendor/front/vendor/hs-file-attach/src/js/hs-file-attach'

// data-controller='hs--file-attach'
// data-hs-file-attach-options='{}' https://htmlstream.com/front/documentation/file-attach.html

export default class extends Controller {
  connect() {
    new HSFileAttach($(this.element)).init()
  }
}
